<template>
  <div class="facilitator-closing">
    <div class="facilitator-profile">
      <div class="profile-image-wrapper">
        <img
          :src="config.facilitatorPhoto"
          :alt="config.facilitatorName || 'Facilitador'"
          @error="handleImageError"
        />
        <div class="profile-badge">
          <i class="icofont-upload"></i>
        </div>
      </div>
      <h3>{{ config.facilitatorName || 'Facilitador' }}</h3>
      <p>{{ config.facilitatorBio }}</p>
    </div>
    <div class="closing-message">
      <p class="message-text" v-html="`&quot;${step.content}&quot;`"></p>
    </div>
    <div class="closing-footer">
      <div class="footer-content">
        <i class="icofont-heart" style="color: #ef4444;"></i>
        Oficina de Monitoramento e Avaliação'
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacilitatorClosingSlide',
  props: {
    step: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleImageError(event) {
      event.target.src = 'https://i.ibb.co/Jj9vpSkg/avatar-esus-1-X1.jpg'
    },
  },
}
</script>

<style scoped>
.facilitator-closing {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 400px;
}

.facilitator-profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
}

.profile-image-wrapper {
  position: relative;
}

.profile-image-wrapper img {
  width: 128px;
  height: 128px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid white;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.profile-badge {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #0FAFD7;
  color: white;
  padding: 8px;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  box-sizing: border-box;
}

.facilitator-profile h3 {
  margin-top: 16px;
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
}

.facilitator-profile p {
  color: #64748b;
  font-size: 14px;
  max-width: 400px;
  margin-top: 4px;
}

.closing-message {
  max-width: 800px;
}

.message-text {
  font-size: 24px;
  font-weight: 500;
  color: #1e293b;
  line-height: 1.4;
}

.closing-footer {
  margin-top: 32px;
  background: #eff6ff;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #bfdbfe;
  max-width: 800px;
  width: 100%;
}

.footer-content {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #1e40af;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
